import { render } from "./frequencyLimit.vue?vue&type=template&id=0174bb57&scoped=true"
import script from "./frequencyLimit.vue?vue&type=script&lang=js"
export * from "./frequencyLimit.vue?vue&type=script&lang=js"

import "./frequencyLimit.vue?vue&type=style&index=0&id=0174bb57&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0174bb57"

export default script